import { ObjSerUtils } from "../../DiscoveryEngine.TS/Serialization/ObjSerUtils";
import { ObjectSerializer } from "../../DiscoveryEngine.TS/Serialization/ObjectSerializer";
import { ValueEncoder } from "../../DiscoveryEngine.TS/Utils/ValueEncoder";
import { List } from "../../DiscoveryEngine.TS/Utils/List";
import { StorageRootDto } from "../StorageRootDto";
import { DiscoveryTaskHandle } from "../../DiscoveryEngine.TS/DiscoveryService";
import { DiscoverySubtaskStatus } from "../../DiscoveryEngine.TS/Discovery/DiscoverySubtaskStatus";


export enum TaskState {
	Created,
	Running,
	Canceled,
	TimedOut,
	Faulted,
	Complete
}


export enum DiscoveryPhase {
	None,
	IpDiscovery,
	HostnameDiscovery,
	DetailedDiscovery,
	ConnectivityProcessing,
	Complete
}


export class DeviceCounts implements ObjectSerializer {

	public AllDevices: number;
	public Routers: number;
	public Switches: number;
	public WirelessAPs: number;
	public Firewalls: number;
	public WirelessControllers: number;
	public OtherNetDevices: number;
	public Servers: number;
	public Workstations: number;
	public Printers: number;
	public IpPhones: number;
	public IpPhoneManagers: number;
	public OtherDevices: number;

	constructor() {
		this.Clear();
	}

	public Clear(): void {
		this.AllDevices = 0;
		this.Routers = 0;
		this.Switches = 0;
		this.WirelessAPs = 0;
		this.Firewalls = 0;
		this.WirelessControllers = 0;
		this.OtherNetDevices = 0;
		this.Servers = 0;
		this.Workstations = 0;
		this.Printers = 0;
		this.IpPhones = 0;
		this.IpPhoneManagers = 0;
		this.OtherDevices = 0;
	}

	public Copy(other: DeviceCounts): void {
		this.AllDevices = other.AllDevices;
		this.Routers = other.Routers;
		this.Switches = other.Switches;
		this.WirelessAPs = other.WirelessAPs;
		this.Firewalls = other.Firewalls;
		this.WirelessControllers = other.WirelessControllers;
		this.OtherNetDevices = other.OtherNetDevices;
		this.Servers = other.Servers;
		this.Workstations = other.Workstations;
		this.Printers = other.Printers;
		this.IpPhones = other.IpPhones;
		this.IpPhoneManagers = other.IpPhoneManagers;
		this.OtherDevices = other.OtherDevices;
	}

	public Write(obj: any, context: any): void {
		obj.device_counts = {};
		obj = obj.device_counts;

		obj.all_devices = ValueEncoder.EncodeInteger(this.AllDevices);
		obj.routers = ValueEncoder.EncodeInteger(this.Routers);
		obj.switches = ValueEncoder.EncodeInteger(this.Switches);
		obj.wireless_aps = ValueEncoder.EncodeInteger(this.WirelessAPs);
		obj.firewalls = ValueEncoder.EncodeInteger(this.Firewalls);
		obj.wireless_controllers = ValueEncoder.EncodeInteger(this.WirelessControllers);
		obj.other_network_devices = ValueEncoder.EncodeInteger(this.OtherNetDevices);
		obj.servers = ValueEncoder.EncodeInteger(this.Servers);
		obj.workstations = ValueEncoder.EncodeInteger(this.Workstations);
		obj.printers = ValueEncoder.EncodeInteger(this.Printers);
		obj.ip_phones = ValueEncoder.EncodeInteger(this.IpPhones);
		obj.ip_phone_managers = ValueEncoder.EncodeInteger(this.IpPhoneManagers);
		obj.other_devices = ValueEncoder.EncodeInteger(this.OtherDevices);
	}

	public Read(obj: any, context: any): void {

		if (!obj.device_counts)
			throw new Error();
		obj = obj.device_counts;

		if (obj.all_devices !== undefined)
			this.AllDevices = ValueEncoder.DecodeInteger(obj.all_devices);
		if (obj.routers !== undefined)
			this.Routers = ValueEncoder.DecodeInteger(obj.routers);
		if (obj.switches !== undefined)
			this.Switches = ValueEncoder.DecodeInteger(obj.switches);
		if (obj.wireless_aps !== undefined)
			this.WirelessAPs = ValueEncoder.DecodeInteger(obj.wireless_aps);
		if (obj.firewalls !== undefined)
			this.Firewalls = ValueEncoder.DecodeInteger(obj.firewalls);
		if (obj.wireless_controllers !== undefined)
			this.WirelessControllers = ValueEncoder.DecodeInteger(obj.wireless_controllers);
		if (obj.other_network_devices !== undefined)
			this.OtherNetDevices = ValueEncoder.DecodeInteger(obj.other_network_devices);
		if (obj.servers !== undefined)
			this.Servers = ValueEncoder.DecodeInteger(obj.servers);
		if (obj.workstations !== undefined)
			this.Workstations = ValueEncoder.DecodeInteger(obj.workstations);
		if (obj.printers !== undefined)
			this.Printers = ValueEncoder.DecodeInteger(obj.printers);
		if (obj.ip_phones !== undefined)
			this.IpPhones = ValueEncoder.DecodeInteger(obj.ip_phones);
		if (obj.ip_phone_managers !== undefined)
			this.IpPhoneManagers = ValueEncoder.DecodeInteger(obj.ip_phone_managers);
		if (obj.other_devices !== undefined)
			this.OtherDevices = ValueEncoder.DecodeInteger(obj.other_devices);
	}

}

export class ScheduledDiscoveryStatusDto extends StorageRootDto {

	public UserGuid: string;
	public ScopeGuid: string;
	public AgentGuid: string;
	public ClientAgentGuid: string;
	public SchedDiscGuid: string;
	public State: TaskState;
	public StartTime: string;
	public EndTime: string;
	public Message: string;
	public LastDevice: string;
	public DeviceCounts: DeviceCounts;
	public TotalProgress: number;
	public DiscoveryPhase: DiscoveryPhase;
	public PhaseProgress: number;
	public DiscTaskHandle: DiscoveryTaskHandle;
	public SubtaskStatus: List<DiscoverySubtaskStatus>;

	constructor() {
		super();

		this.UserGuid = "";
		this.ScopeGuid = "";
		this.AgentGuid = "";
		this.ClientAgentGuid = "";
		this.SchedDiscGuid = "";
		this.State = TaskState.Created;
		this.StartTime = "";
		this.EndTime = "";
		this.Message = "";
		this.LastDevice = "";
		this.DeviceCounts = new DeviceCounts();
		this.TotalProgress = -1;
		this.DiscoveryPhase = DiscoveryPhase.None;
		this.PhaseProgress = -1;
		this.DiscTaskHandle = null;
		this.SubtaskStatus = new List<DiscoverySubtaskStatus>();
	}

	public get HasUserGuid(): boolean {
		return !!this.UserGuid;
	}

	public get HasScopeGuid(): boolean {
		return !!this.ScopeGuid;
	}

	public get HasAgentGuid(): boolean {
		return !!this.AgentGuid;
	}

	public get HasClientAgentGuid(): boolean {
		return !!this.ClientAgentGuid;
	}

	public get HasSchedDiscGuid(): boolean {
		return !!this.SchedDiscGuid;
	}

	public get HasStartTime(): boolean {
		return !!this.StartTime;
	}

	public get HasEndTime(): boolean {
		return !!this.EndTime;
	}

	public get HasMessage(): boolean {
		return !!this.Message;
	}

	public get HasLastDevice(): boolean {
		return !!this.LastDevice;
	}

	public get HasTotalProgress(): boolean {
		return (this.TotalProgress >= 0);
	}

	public get HasPhaseProgress(): boolean {
		return (this.PhaseProgress >= 0);
	}

	public get HasDiscTaskHandle(): boolean {
		return !!this.DiscTaskHandle;
	}

	public get HasSubtaskStatus(): boolean {
		return (this.SubtaskStatus != null && this.SubtaskStatus.Count > 0);
	}

	public Write(obj: any, context: any): void {
		obj.scheduled_discovery_status = {};
		obj = obj.scheduled_discovery_status;

		super.Write(obj, context);

		if (this.HasUserGuid)
			obj.user_guid = this.UserGuid;

		if (this.ScopeGuid)
			obj.scope_guid = this.ScopeGuid;

		if (this.HasAgentGuid)
			obj.agent_guid = this.AgentGuid;

		if (this.HasClientAgentGuid)
			obj.client_agent_guid = this.ClientAgentGuid;

		if (this.HasSchedDiscGuid)
			obj.sched_disc_guid = this.SchedDiscGuid;

		obj.state = TaskState[this.State];

		if (this.HasStartTime)
			obj.start_time = this.StartTime;

		if (this.HasEndTime)
			obj.end_time = this.EndTime;

		if (this.HasMessage)
			obj.message = this.Message;

		if (this.HasLastDevice)
			obj.last_device = this.LastDevice;

		this.DeviceCounts.Write(obj, context);

		if (this.HasTotalProgress)
			obj.total_progress = ValueEncoder.EncodeInteger(this.TotalProgress);

		obj.discovery_phase = DiscoveryPhase[this.DiscoveryPhase];

		if (this.HasPhaseProgress)
			obj.phase_progress = ValueEncoder.EncodeInteger(this.PhaseProgress);

		if (this.HasDiscTaskHandle) {
			this.DiscTaskHandle.Write(obj, context);
		}

		if (this.HasSubtaskStatus) {
			obj.subtask_status = [];
			ObjSerUtils.WriteObjSerCollection(obj.subtask_status, this.SubtaskStatus, context);
		}
	}

	public Read(obj: any, context: any): void {

		if (!obj.scheduled_discovery_status)
			throw new Error();
		obj = obj.scheduled_discovery_status;

		super.Read(obj, context);

		if (obj.user_guid !== undefined)
			this.UserGuid = obj.user_guid;

		if (obj.scope_guid !== undefined)
			this.ScopeGuid = obj.scope_guid;

		if (obj.agent_guid !== undefined)
			this.AgentGuid = obj.agent_guid;

		if (obj.client_agent_guid !== undefined)
			this.ClientAgentGuid = obj.client_agent_guid;

		if (obj.sched_disc_guid !== undefined)
			this.SchedDiscGuid = obj.sched_disc_guid;

		if (obj.state !== undefined)
			this.State = TaskState[<string>obj.state];

		if (obj.start_time !== undefined)
			this.StartTime = obj.start_time;

		if (obj.end_time !== undefined)
			this.EndTime = obj.end_time;

		if (obj.message !== undefined)
			this.Message = obj.message;

		if (obj.last_device !== undefined)
			this.LastDevice = obj.last_device;

		if (obj.device_counts !== undefined) {
			this.DeviceCounts = new DeviceCounts();
			this.DeviceCounts.Read(obj, context);
		}

		if (obj.total_progress !== undefined)
			this.TotalProgress = ValueEncoder.DecodeInteger(obj.total_progress);

		if (obj.discovery_phase !== undefined)
			this.DiscoveryPhase = DiscoveryPhase[<string>obj.discovery_phase];

		if (obj.phase_progress !== undefined)
			this.PhaseProgress = ValueEncoder.DecodeInteger(obj.phase_progress);

		if (obj.discovery_task_handle !== undefined) {
			this.DiscTaskHandle = new DiscoveryTaskHandle();
			this.DiscTaskHandle.Read(obj, context);
		}

		if (obj.subtask_status !== undefined) {
			ObjSerUtils.ReadObjSerCollection(obj.subtask_status, this.SubtaskStatus,
				(_value: any) => new DiscoverySubtaskStatus(), context);
		}
	}

}
